import React from "react";
import styled from "styled-components";
import { COLORS } from "@app/constants";
import { View } from "@/styles/reactnative";
import DerivativesCheckBox from "./DerivativesCheckBox";
import TimeInForceDropdown from "./TimeInForceDropdown";
import useTradeStore from "@app/hooks/trade/tradeStore";

const DerivativesCheckBoxs = () => {
  const { data, mutate: mutateTradeStore } = useTradeStore();

  const isMarket = data?.limit_market === "M";
  const isLimitOrder = data?.limit_market === "L";

  return (
    <DerivativesCheckBoxSection>
      <View
        style={{
          alignItems: "flex-start",
          flexDirection: "row",
          gap: 10,
        }}
      >
        {/*{!isMarket && (*/}
        {/*  <DerivativesCheckBox*/}
        {/*    title={"postOnly"}*/}
        {/*    checked={data?.post_only}*/}
        {/*    action={(checked) => {*/}
        {/*      mutateTradeStore({ ...data, post_only: checked });*/}
        {/*    }}*/}
        {/*  />*/}
        {/*)}*/}
        <DerivativesCheckBox
          title={"reduceOnly"}
          checked={data?.reduce_only}
          action={(checked) => {
            mutateTradeStore({ ...data, reduce_only: checked });
          }}
        />
      </View>
      {/* Time In Force 드롭다운 (지정가 주문일 때만 표시) */}
      {isLimitOrder && <TimeInForceDropdown />}
    </DerivativesCheckBoxSection>
  );
};
const DerivativesCheckBoxSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: ${COLORS.lightGray1};
  margin-top: 10px;
  width: 100%;
`;
export default DerivativesCheckBoxs;
